import { ArrowRight, Award } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import drLarkinHeadshot from '@/assets/dr-larkin-headshot.jpg';

const FounderNarrativeSection = () => {
  return (
    <section className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Image */}
          <div className="relative flex justify-center lg:justify-start">
            <div className="relative w-72 sm:w-80 md:w-96">
              <div className="relative rounded-md overflow-hidden border border-border">
                <img
                  src={drLarkinHeadshot}
                  alt="Dr. John J. Larkin, M.D. — Founder of LINK"
                  className="w-full h-auto object-cover"
                  loading="lazy"
                />
              </div>
              {/* Badge */}
              <div className="absolute -top-3 -right-3 z-10">
                <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-warning/10 border border-warning/20">
                  <Award className="h-3.5 w-3.5 text-warning" />
                  <span className="text-xs font-semibold text-warning">Top Doctor 2025</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Text — left-aligned */}
          <div className="space-y-6">
            <span className="text-xs font-medium text-primary tracking-wide uppercase">Our Founder</span>

            <h2 className="text-3xl md:text-4xl font-bold text-foreground tracking-tight leading-tight">
              40 Years in the OR. One Mission.
            </h2>

            <p className="text-lg text-muted-foreground leading-relaxed max-w-xl">
              Dr. John Larkin saw a systemic failure in surgical billing. LINK is his answer—an
              enforcement layer designed by a surgeon to protect the financial integrity of the
              modern hospital.
            </p>

            <div className="border-l-2 border-primary/30 pl-4 py-1">
              <p className="text-sm text-foreground/80 font-medium italic">
                "Past Chairman, Ohio Governor's Advisory Board for Workers' Compensation."
              </p>
            </div>

            <div className="pt-2">
              <Link to="/company">
                <Button variant="outline" className="border-border hover:bg-muted text-foreground group">
                  Read Dr. Larkin's Full Story
                  <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderNarrativeSection;
